/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const previewScheduleArchiveBodyExpectedVersionExclusiveMin = 0;
export const previewScheduleArchiveBodyExpectedVersionMax = 9007199254740991;

export const PreviewScheduleArchiveBody = zod.object({
  expectedVersion: zod
    .int()
    .gt(previewScheduleArchiveBodyExpectedVersionExclusiveMin)
    .max(previewScheduleArchiveBodyExpectedVersionMax),
});

export type PreviewScheduleArchiveBody = zod.input<typeof PreviewScheduleArchiveBody>;
export type PreviewScheduleArchiveBodyOutput = zod.output<typeof PreviewScheduleArchiveBody>;
